// CacheKey 51da701d8238cf11dcafcc2ffdf7bd8c
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-LHC": {
    simple_form: {
      labels: {
        encounter: {
          arrival_date: "Enrollment Date",
          discharge_date: "Disenrollment Date",
          discharge_disposition: "Disenrollment Reason",
          discharged_by: "Disenrolled By",
          encounter_class: "Enrollment Class",
          encounter_id: "Enrollment ID",
          facility: "State",
          patient_class: "Patient Status",
          risk_score_1_on_discharge: "Enrollment Type",
          surgical_encounter_status: "Surgical Enrollment Status",
          unit: "Agency",
          unit_id: "Agency",
          unit_name: "Agency"
        },
        patient: {
          unit_name: "Agency",
          encounter_id: "Enrollment"
        },
        unit: {
          facility: "State",
          short_title: "Agency Name"
        }
      }
    }
  }
}

